

































































































import { Component, Mixins } from 'vue-property-decorator';

import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import {
  ListingStatus,
  ListingCategory,
} from 'client-website-ts-library/types';

import { View } from 'client-website-ts-library/plugins';

import { EmbeddedContent, EmbeddedContentType } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';
import Listings from '../components/Listings.vue';
import SideBySide from '../components/Layout/SideBySide.vue';
import ItemCycler from '../components/Cycler/ItemCycler.vue';
import WelcomeModal from '../components/WelcomeModal.vue';
import Embeddable from '../components/Common/Embeddable.vue';

import { ItemCyclerSlide, ItemCyclerImageSlide } from '../app_code/ItemCycler';

@Component({
  components: {
    Listings,
    SideBySide,
    ItemCycler,
    WelcomeModal,
    Embeddable,
  },
})
export default class Home extends Mixins(View) {
  private listingFilter = new ListingFilter({
    Statuses: [
      ListingStatus.Current,
      ListingStatus.UnderContract,
    ],
    Categories: [
      ListingCategory.ResidentialSale,
      ListingCategory.ResidentialLand,
    ],
    PageSize: 6,
    OrderByStatements: [
      ListingOrderBy.CreateDateDesc,
    ],
  });

  get year(): string {
    return new Date().getFullYear().toString();
  }

  private cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/1', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }),
    new ItemCyclerImageSlide({ source: '/assets/images/home/slider/2', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }),
  ];

  private eb: EmbeddedContent = {
    Type: EmbeddedContentType.Youtube,
    EmbedId: 'BnfOFLpdEBc',
  };
}
